import React from 'react'
import { capitalize } from 'lodash'

import { InteractiveTooltip } from '@/components/tooltips/InteractiveTooltip'

export default React.memo(({ slateObjectType, children }) => (
  <InteractiveTooltip
    placement="top"
    content={
      slateObjectType === 'inline-verbatim-container'
        ? 'Inline Phrase Matching'
        : slateObjectType.split('-').map((word) => `${capitalize(word)} `)
    }
  >
    {children}
  </InteractiveTooltip>
))
